import React, { useEffect, useState } from 'react';
import CompaniesView from './CompaniesView';
import { BE_URL, httpGet } from '../../http';

const Companies = (props) => {

    useEffect(async () => {

        if(localStorage.getItem('nitProveedor')){
            await explore();
        } else {
            if(!sessionStorage.getItem('proveedor')){
                props.history.push('/login');
                return 0;
            }
        }

        getCompanies();
    }, []);

    const [ data, setData ] = useState({
        empresas: [],
        loading: false,
        error: false,
        errorMsg: ''
    });

    const getCompanies = async () => {
        try{
            setData({
                ...data,
                loading: true
            });
    
            let companies = await httpGet(BE_URL + '/ProveedoresWS/api/empresa');
            console.log("COMPANIES");
            console.log(companies);
            if(companies){
                setData({
                    ...data,
                    empresas: companies.data,
                    loading: true
                }); 
            }
        } catch(error){
            setData({
                ...data,
                loading: false,
                error: true,
                erroMsg: 'Ocurrio un error!'
            });
        }
    }

    const explore = async () => {
        try{
            const proveedor = await httpGet(BE_URL + '/ProveedoresWS/api/proveedor/nit/' + localStorage.getItem("nitProveedor"));
            sessionStorage.setItem('proveedor', JSON.stringify(proveedor.data));
            localStorage.removeItem("nitProveedor")
        } catch(error){

        }
    }

    const handleClick = (id) => {
        console.log("CLICK!");
        sessionStorage.setItem('companyId', JSON.stringify(id));
        props.history.push('/portal');
    }

    return(<CompaniesView data={data} onClick={handleClick} />);
}

export default Companies;